import { render, staticRenderFns } from "./fdInventory12.vue?vue&type=template&id=6437651f"
import script from "./fdInventory12.vue?vue&type=script&lang=js"
export * from "./fdInventory12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports